// Handles the OAuth PKCE callback redirect from Kinde
// Called at startup to exchange the authorization code for tokens
export async function handleOAuthCallback() {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location.href);
  const code = url.searchParams.get('code');
  const error = url.searchParams.get('error');

  if (error) {
    console.error('[Auth] OAuth error:', error, url.searchParams.get('error_description'));
    url.searchParams.delete('code');
    url.searchParams.delete('error');
    url.searchParams.delete('error_description');
    url.searchParams.delete('state');
    window.history.replaceState({}, document.title, url.pathname + url.search);
    return;
  }

  if (!code) return;

  const verifier = sessionStorage.getItem('kinde_pkce_verifier');
  if (!verifier) {
    console.warn('[Auth] OAuth callback received but no PKCE verifier found');
    return;
  }

  // Validate the OAuth `state` to guard against CSRF.
  const returnedState = url.searchParams.get('state');
  const expectedState = sessionStorage.getItem('kinde_oauth_state');
  if (expectedState && returnedState !== expectedState) {
    console.error('[Auth] OAuth state mismatch — aborting token exchange');
    sessionStorage.removeItem('kinde_oauth_state');
    url.searchParams.delete('code');
    url.searchParams.delete('state');
    window.history.replaceState({}, document.title, url.pathname + url.search);
    return;
  }

  const issuerUrl = process.env.KINDE_ISSUER_URL;
  const clientId = process.env.KINDE_CLIENT_ID;
  const callbackUrl = process.env.KINDE_POST_CALLBACK_URL || window.location.origin;

  if (!issuerUrl || !clientId) {
    console.error('[Auth] Missing Kinde env vars — set KINDE_ISSUER_URL and KINDE_CLIENT_ID in .env.dev');
    return;
  }

  try {
    const response = await fetch(`${issuerUrl}/oauth2/token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        grant_type: 'authorization_code',
        client_id: clientId,
        redirect_uri: callbackUrl,
        code_verifier: verifier,
        code,
      }).toString(),
    });

    const data = await response.json();

    if (data.access_token) {
      localStorage.setItem('kinde_access_token', data.access_token);
      if (data.refresh_token) localStorage.setItem('kinde_refresh_token', data.refresh_token);
      sessionStorage.removeItem('kinde_pkce_verifier');
      sessionStorage.removeItem('kinde_oauth_state');
      console.log('[Auth] OAuth callback handled — tokens stored');
    } else {
      console.error('[Auth] Token exchange failed:', data);
    }
  } catch (err) {
    console.error('[Auth] Token exchange error:', err);
  }

  // Clean up URL params regardless
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  window.history.replaceState({}, document.title, url.pathname + url.search);
}
